import { useState } from "react";
import { Offcanvas, Button } from "react-bootstrap";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { AddCGIJobDetails } from "../../../../../redux/action/client/JobForm";
import ErrorMessage from "../../../../common/ErrorMessage";
import Loader from "../../../../common/Loader";

function AddCGIForm({ match, setReloadElements }) {
  const { jobId } = match.params;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    setError("");
  };
  const handleShow = () => setShow(true);
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    const dataValue = { job: Number(jobId) };
    const finalResult = Object.assign(data, dataValue);
    dispatch(
      AddCGIJobDetails(
        finalResult,
        setLoading,
        setError,
        handleClose,
        setReloadElements
      )
    );
    reset();
  };

  return (
    <>
      <div className="me-sm-2 my-sm-0 my-2">
        <Button
          onClick={handleShow}
          className="atech-primary-button  primary-button-padding w-100"
        >
          Add CGI (Computer Generated Images)
        </Button>

        <Offcanvas
          className="Sidebar-width h-100vh "
          show={show}
          onHide={handleClose}
          placement="end"
        >
          <Offcanvas.Body className="d-flex justify-content-center   pt-lg-2">
            <div className="container">
              <Offcanvas.Header
                className="p-0 pt-2 d-flex justify-content-end"
                closeButton
              ></Offcanvas.Header>
              <h1 className="dash_head pb-lg-4 pb-3 pt-3">
                Add CGI (Computer Generated Images)
              </h1>
              <form onSubmit={handleSubmit(onSubmit)}>
                {error !== "" ? <ErrorMessage message={error} /> : ""}
                <div className="my-2">
                  <Form.Group
                    className=" textarea-focus"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Control
                      {...register("details", { required: true })}
                      placeholder="Describe CGI effect"
                      as="textarea"
                      rows={5}
                      className="inputs_font_size"
                    />
                    {errors.details?.type === "required" && (
                      <p className="common-text xxs-font text-red">
                        Describe CGI effect is required
                      </p>
                    )}
                  </Form.Group>
                </div>

                <div className="d-flex flex-sm-row  flex-column mt-3">
                  <button
                    className={`${
                      loading ? "cursor-not-allowed" : ""
                    } px-4 atech-primary-button  py-sm-2 py-2 ms-sm-2  my-2`}
                    disabled={loading}
                  >
                    {loading ? <Loader /> : "Save"}
                  </button>
                  <button
                    className="px-4  py-sm-2 py-2 ms-sm-2  my-2  atech-fade-button"
                    onClick={handleClose}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </>
  );
}

export default withRouter(AddCGIForm);
